import React from "react";
import { Badge } from "@chakra-ui/react";
import { SUPPLIER_STATUS_CONFIG } from "../suppliersMock";

// Coloured pill for a supplier's lifecycle status (Pending / Active /
// Inactive / Archived). Colour mapping lives in SUPPLIER_STATUS_CONFIG.
function SupplierStatusBadge({ status }) {
  const cfg = SUPPLIER_STATUS_CONFIG[status];
  if (!cfg) return null;
  return (
    <Badge bg={cfg.bg} color={cfg.color} borderRadius="full" px={2.5} py={0.5} fontSize="11px" fontWeight="600" textTransform="none">
      {cfg.label}
    </Badge>
  );
}

export default SupplierStatusBadge;
